import script from "./AssessmentCost.vue?vue&type=script&setup=true&lang=js"
export * from "./AssessmentCost.vue?vue&type=script&setup=true&lang=js"

import "./AssessmentCost.vue?vue&type=style&index=0&id=736223bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-736223bc"]])

export default __exports__